var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FETable',_vm._g({staticClass:"operations-table",attrs:{"data":_vm.data,"headers":_vm.headers,"sort-key":_vm.filters.sortKey,"sort-direction":_vm.filters.sortDirection,"value-key":"id"},scopedSlots:_vm._u([{key:"td-date",fn:function(ref){
var value = ref.value;
return [_c('span',{staticClass:"operations-table__date",domProps:{"textContent":_vm._s(value)}})]}},{key:"td-assessment",fn:function(ref){
var value = ref.value;
return [_c('OperationsAssessment',{attrs:{"assessment":value}})]}},{key:"td-type",fn:function(ref){
var value = ref.value;
return [_c('OperationsType',{attrs:{"type":value}})]}}])},_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }